/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTeamsUserTeamInvitationsQueryResponse,
  GetTeamsUserTeamInvitations401,
  GetTeamsUserTeamInvitations500,
} from "../types/GetTeamsUserTeamInvitations.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTeamsUserTeamInvitationsQueryKey = () =>
  [{ url: "/teams/user/team-invitations" }] as const;

export type GetTeamsUserTeamInvitationsQueryKey = ReturnType<
  typeof getTeamsUserTeamInvitationsQueryKey
>;

/**
 * @description Возвращает все активные приглашения пользователя в команды.
 * Используется для отображения в профиле и уведомлениях.
 * @summary Получить все приглашения текущего пользователя
 * {@link /teams/user/team-invitations}
 */
export async function getTeamsUserTeamInvitations(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTeamsUserTeamInvitationsQueryResponse,
    ResponseErrorConfig<
      GetTeamsUserTeamInvitations401 | GetTeamsUserTeamInvitations500
    >,
    unknown
  >({ method: "GET", url: `/teams/user/team-invitations`, ...requestConfig });
  return res;
}

export function getTeamsUserTeamInvitationsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTeamsUserTeamInvitationsQueryKey();
  return queryOptions<
    ResponseConfig<GetTeamsUserTeamInvitationsQueryResponse>,
    ResponseErrorConfig<
      GetTeamsUserTeamInvitations401 | GetTeamsUserTeamInvitations500
    >,
    ResponseConfig<GetTeamsUserTeamInvitationsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTeamsUserTeamInvitations({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Возвращает все активные приглашения пользователя в команды.
 * Используется для отображения в профиле и уведомлениях.
 * @summary Получить все приглашения текущего пользователя
 * {@link /teams/user/team-invitations}
 */
export function useGetTeamsUserTeamInvitations<
  TData = ResponseConfig<GetTeamsUserTeamInvitationsQueryResponse>,
  TQueryData = ResponseConfig<GetTeamsUserTeamInvitationsQueryResponse>,
  TQueryKey extends QueryKey = GetTeamsUserTeamInvitationsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTeamsUserTeamInvitationsQueryResponse>,
        ResponseErrorConfig<
          GetTeamsUserTeamInvitations401 | GetTeamsUserTeamInvitations500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getTeamsUserTeamInvitationsQueryKey();

  const query = useQuery(
    {
      ...getTeamsUserTeamInvitationsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetTeamsUserTeamInvitations401 | GetTeamsUserTeamInvitations500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
